import { NO_NEXT_REVIEW, RETRIEVED_NEXT_REVIEW } from "../actions/NextReviewActions";
import { getAllRandomSamples } from "../utils/randomSample"

const initialState = {
    empty: true,
    info: null,
    duration: 0,
    fileSize: 0
}

export default function reviewReducer(state = initialState, action) {
    const nextState = Object.assign({}, state);

    switch (action.type) {
        case RETRIEVED_NEXT_REVIEW:
            nextState.empty = false;
            nextState.attachedImageUrl = action.review.review.reviewType === "PICTURE" ? action.review.attachedImageUrl : action.review.evidenceUrl;
            nextState.info = action.review.review;
            nextState.songInfo = action.review.actualSongInformation;
            if (action.review.actualSongInformation != null) {
                nextState.samples = getAllRandomSamples(action.review.actualSongInformation.fileSize, action.review.actualSongInformation.duration);
            }
            return nextState;
        case NO_NEXT_REVIEW:
            nextState.empty = true;
            nextState.info = null;
            nextState.duration = 0;
            nextState.fileSize = 0;
            return nextState;
        default:
            return nextState;
    }
}
